import React, { useCallback, useEffect, useMemo, useReducer, useState } from 'react'
import { PersonalAprobarDetalleMarcacion } from './TypePersonalAprobarMarcacion'
import { reducer } from './ReducerPersonalAprobar'
import { ScrollToTop } from 'functions/LayoutFunctionst'
import { ObtenerDetallesServidor, ObtenerListadoServidores } from './FunctionsPersonalAprobar'
import { alertService } from 'components/Varios/alert_service'
import TablaPersonalMarcaciones from "./TablaPersonalAprobar";
import Cargando from 'components/Varios/Cargando'
import { Col, Row, Container, Table, Form, FormGroup, Label, Input } from 'reactstrap'
import { DetalleMarcacionesServidor, TablaDetalleES } from 'components/UsuarioGeneral/Registro Entrada Salida/typesRegistroEntradaSalida'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew'
import { listadoMeses } from 'functions/DatesFunctions'
import "../../../../assets/scss/Marcaciones/tablaPersonal.scss";
import { ESTADOS_CON_NOVEDAD, ESTADO_REGISTRO_JUSTIFICADO } from '../../../UsuarioGeneral/Registro Entrada Salida/RegistroEntradaSalidaAlmuerzo'
import CalendarComponent from 'components/UsuarioGeneral/Registro Entrada Salida/CalendarComponent'
import { GetHojaMarcacion } from 'components/UsuarioGeneral/Hoja Marcaciones/ServicesHojaMarcaciones'
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import ModalCargando from 'components/Varios/ModalCargando'




export type InformacionGeneralPersonalAprobar = {
    mesActual: number,
    anioActual: number,
    listadoPersonal: PersonalAprobarDetalleMarcacion[],
    fechaActual: string
}
export type StateModalDetalle = {
    loading: boolean,
    informacion: DetalleMarcacionesServidor,
    nombre: string,
    year: number,
    month: number,
    idPersona: number,
    identificacion: string,
    consultaApiCalendario: boolean
}

export type PropertyForm = {
    name: string,
    value: any
}

export type ParametersModal = {
    year: number,
    month: number,
    idPersona: number,
    identificacion: string,
    consultaApiCalendario: boolean
}



export type PersonalAprobarAccion =
    | { type: "OBTENER_INFORMACION" }
    | { type: "INFORMACION_CARGADA", payload: InformacionGeneralPersonalAprobar | undefined }
    | { type: "INFORMACION_CARGADA_NOVEDAD", payload: InformacionGeneralPersonalAprobar | undefined }
    | { type: "OBTENER_INFORMACION_MODAL", payload: ParametersModal }
    | { type: "INFORMACION_CARGADA_MODAL", payload: StateModalDetalle }
    | { type: "CERRAR_MODAL", payload: ParametersModal }
    | { type: "ACTUALIZAR_STATE_MODAL_SELECT", payload: StateModalDetalle }
    | { type: "ACTUALIZAR_MES_CONSULTA", payload: number }
    | { type: "DESCARGAR_HOJA" }
    | { type: "HOJA_DESCARGADA" }



export type PersonalAprobarState = {
    loadingInfo: boolean,
    loadingHoja: boolean,
    listadoPersonal: PersonalAprobarDetalleMarcacion[],
    novedad: boolean,
    mesActual: number,
    anioActual: number,
    stateModalDetalle: StateModalDetalle,
    fechaActual: string
}


export default function PersonalAprobar() {


    const JUSTIFICACIONES_MARCACION = [ESTADO_REGISTRO_JUSTIFICADO]


    const fechaActual = new Date()
    const initialState: PersonalAprobarState = {
        listadoPersonal: [],
        fechaActual: new Date().toISOString(),
        anioActual: fechaActual.getFullYear(),
        mesActual: fechaActual.getMonth() + 1,
        loadingInfo: false,
        loadingHoja: false,
        novedad: false,
        stateModalDetalle: {
            informacion: {
                detalle: [],
                horarioLaboral: {
                    horaEntrada: "",
                    horaSalida: ""
                }
            },
            nombre: "",
            loading: false,
            year: fechaActual.getFullYear(),
            month: fechaActual.getMonth() + 1,
            idPersona: -1,
            identificacion: "",
            consultaApiCalendario: false

        }
    }
    const [state, dispatch] = useReducer(reducer, initialState);
    const [tableHeight, setTableHeight] = useState('300px')


    async function ObtenerInformacionGeneral(month?: number) {
        ScrollToTop();
        dispatch({ type: "OBTENER_INFORMACION" });

        const respuesta = await ObtenerListadoServidores(month);

        if (respuesta.status !== 200) {
            dispatch({ type: "INFORMACION_CARGADA_NOVEDAD", payload: respuesta.dataResponse })
            alertService.error(respuesta.errorMessage);
        }
        else {
            dispatch({ type: "INFORMACION_CARGADA", payload: respuesta.dataResponse })
        }


    }

    async function ConsultarDetalleMarcaciones(idPersona: number, nombre: string, identificacion: string, month: number, year: number) {

        var consultaApiCalendario: boolean = false;

        //Month usa el valor del indice del mes.
        if (year === 2024 && month >= 11 || year >= 2025) {
            consultaApiCalendario = true;
        }


        if (consultaApiCalendario) {
            dispatch({ type: "OBTENER_INFORMACION_MODAL", payload: { month, year, idPersona, identificacion, consultaApiCalendario } });
            dispatch({
                type: "INFORMACION_CARGADA_MODAL", payload: {
                    informacion: {
                        detalle: []
                        , horarioLaboral: {
                            horaEntrada: ""
                            , horaSalida: ""
                        }
                    }
                    , nombre
                    , loading: false
                    , month
                    , year
                    , idPersona
                    , identificacion
                    , consultaApiCalendario
                }
            })
        }
        else {
            dispatch({ type: "OBTENER_INFORMACION_MODAL", payload: { month, year, idPersona, identificacion, consultaApiCalendario } });
            const respuesta = await ObtenerDetallesServidor(idPersona, month, year);

            if (respuesta.status !== 200) {
                dispatch({ type: "INFORMACION_CARGADA_MODAL", payload: { informacion: { detalle: [], horarioLaboral: { horaEntrada: "", horaSalida: "" } }, nombre: nombre, loading: false, month, year, idPersona, identificacion, consultaApiCalendario } })
                alertService.error(respuesta.errorMessage);
            }
            else if (respuesta.status === 200 && respuesta.dataResponse) {

                dispatch({ type: "INFORMACION_CARGADA_MODAL", payload: { informacion: respuesta.dataResponse, nombre, loading: false, month, year, idPersona, identificacion, consultaApiCalendario } })

            }
            else {
                alertService.error(respuesta.errorMessage);
            }

        }




    }


    async function DescargarHojaMarcaciones(identificacion: string, mesconsulta: number, fechaactual: string) {
        dispatch({ type: "DESCARGAR_HOJA" })
        const fechaActual: Date = new Date(fechaactual);

        var fechaDesde: Date = new Date(fechaActual.getFullYear(), mesconsulta - 1, 1);
        var fechaHasta: Date = new Date(fechaActual.getFullYear(), mesconsulta, 0);


       /* console.log(fechaActual)
        console.log(fechaDesde)
        console.log(fechaHasta)*/

        if (mesconsulta - 1 === fechaActual.getMonth()) {
            fechaHasta = fechaActual
        }

        console.log(fechaHasta)


        const respuestaHoja = await GetHojaMarcacion(fechaDesde, fechaHasta, identificacion)

        if (respuestaHoja.status === 200 && respuestaHoja.dataResponse) {
            const enlaceDescarga = respuestaHoja.dataResponse;
            let a = document.createElement('a');
            a.href = enlaceDescarga;
            a.download = "HojaMarcaciones" +  identificacion +".pdf"  //nombrearchivo
            a.click()
        }
        else{
            showAlert("Ha ocurrido un inconveniente al intentar descargar la Hoja de Marcaciones indicada",false);
        }


        dispatch({ type: "HOJA_DESCARGADA" })
    }


    const HandleChangeValue = useCallback(async (name: string, value: number, informacionModal: StateModalDetalle) => {
        if (name === "year") {
            dispatch({ type: "ACTUALIZAR_STATE_MODAL_SELECT", payload: { ...informacionModal, year: value } })
        }
        if (name === "month") {
            dispatch({ type: "ACTUALIZAR_STATE_MODAL_SELECT", payload: { ...informacionModal, month: value } })
        }



    }, [state.stateModalDetalle.year, state.stateModalDetalle.month])

    const updateTableHeight = () => {
        const windowHeight = window.innerHeight;
        // You can adjust the calculation based on your needs
        const newHeight = windowHeight * 0.7; // Set the percentage of the window height you want the table to take
        setTableHeight(`${newHeight}px`);
    };

    useEffect(() => {


        if (state.stateModalDetalle.idPersona > 0) {
            const { idPersona, month, year, nombre, identificacion, consultaApiCalendario } = state.stateModalDetalle;
            ConsultarDetalleMarcaciones(idPersona, nombre, identificacion, month, year);
        }

    }, [state.stateModalDetalle.month, state.stateModalDetalle.year])

    const GenerarTablaDetalleMarcacion = useCallback((informacionModal: StateModalDetalle) => {

        const explicacionEstadoRC = "El servidor ha realizado completamente sus marcaciones de entrada y salida de labores y/o de receso.";
        const explicacionEstadoRI = "El servidor ha incumplido en una de sus marcaciones de entrada o salida de labores y/o de receso";
        const explicacionEstadoRE = "El servidor ha completado sus marcaciones de entrada y salida de receso, pero ha excedido su tiempo máximo";
        const explicacionEstadoAR = "El servidor ha incumplido en sus marcaciones de entrada y salida de labores y/o receso.";


        const { informacion, consultaApiCalendario, identificacion, nombre, loading, month, year } = informacionModal;



        //if (informacion.detalle.length === 0 && !loading) {
        if (identificacion === "" && !loading) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle</p>
                </>
            )
        }
        else if (loading) {
            return (

                <Cargando />

            )
        }
        else {

            // const horarioEntrada = informacion.horarioLaboral.horaEntrada;
            // const horarioSalida = informacion.horarioLaboral.horaSalida;
            // const horarioEntradaFormato = horarioEntrada.split(":")[0] + ":" + horarioEntrada.split(":")[1]
            // const horarioSalidaFormato = horarioSalida.split(":")[0] + ":" + horarioSalida.split(":")[1]
            var opcionesMes = listadoMeses;
            if (year === 2023) {
                opcionesMes = listadoMeses.filter(om => om.valorMes >= 11);
            }

            const anioActual = fechaActual.getFullYear();
            var anioIterador = 2023;

            var opcionesAnio: number[] = []

            while (anioIterador <= anioActual) {
                opcionesAnio.push(anioIterador);
                anioIterador += 1;
            }




            const colSm = 6;
            const colMd = 6;
            const colXl = 2;
            const colL = 3;
            const tabla =

                <>

                    <div>Nombre:  {nombre}</div>
                    {/* <div>Horario laboral : {horarioEntradaFormato} - {horarioSalidaFormato}</div> */}
                    <div>

                        <em className="bold textEspolColor-blue">
                            El cumplimiento de la jornada laboral, es un proceso posterior en donde se validan permisos, vacaciones, licencias o comisiones de servicio que
                            hayan mantenido durante el mes de labores
                        </em>


                    </div>
                    <Row>
                        <Col sm={colSm} md={colMd} lg={colL} xl={colXl}>
                            <div>
                                <label className="lbMes mr-1" htmlFor="selectMonth">Mes: </label>
                                <select id="selectMonth" name={"month"} value={month} onChange={(e) => HandleChangeValue(e.target.name, +e.target.value, informacionModal)}>
                                    {opcionesMes.map((v, i) => {
                                        return (
                                            <option value={v.valorMes}>{v.mes}</option>
                                        )
                                    })}
                                </select>
                            </div>

                        </Col>
                        <Col sm={colSm} md={colMd} lg={colL} xl={colXl}>
                            <div>
                                <label className="lbMes mr-1" htmlFor="selectYear">Año: </label>
                                <select id="selectYear" name={"year"} value={year} onChange={(e) => HandleChangeValue(e.target.name, +e.target.value, informacionModal)}>
                                    {
                                        opcionesAnio.map((v, i) => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })

                                    }
                                </select>
                            </div>

                        </Col>
                    </Row>

                    {
                        !consultaApiCalendario && informacion.detalle.length > 0 && !loading &&
                        <>
                            <div id="containterTableMarcaciones" className='table-responsive'>
                                <Table id="tablaMarcacionesDetalle" bordered className="tableMarcacionesDetalle "  >
                                    <thead className="cabecerasDetallehistorialSolic">
                                        {/* <tr >
                                    <th> </th>
                                    <th colSpan={3}>
                                        Marcación de Labores
                                    </th>
                                    <th colSpan={3}>
                                        Marcación de receso
                                    </th>
                                    <th colSpan={4}>
                                        Estados
                                    </th>
                                </tr>
                    
                                <tr className="subCabecera">
                    
                                    <th> Fecha </th>
                                    <th> Entrada</th>
                                    <th> Salida</th>
                                    <th> Duración jornada</th>
                                    <th> Entrada</th>
                                    <th> Salida</th>
                                    <th> Duración receso</th>
                                    <th> Horario laboral</th>
                                    <th> Horario  receso</th>
                                    <th> Justif horario laboral </th>
                                    <th> Justif horario receso</th>
                    
                                </tr> */}

                                        <tr className="" >
                                            <th> Fecha</th>
                                            <th> Hora inicio labores</th>
                                            <th> Hora inicio receso</th>
                                            <th> Hora fin receso</th>
                                            <th> Hora fin labores</th>
                                            <th> Total horas</th>
                                            <th> Duración receso</th>
                                            <th> Estado laboral</th>
                                            <th> Estado receso</th>

                                            <th> Estado solicitud laboral</th>
                                            <th> Estado solicitud receso</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            informacion.detalle.map((infoDetalle, indinfoHist) => {

                                                var classNameestadoL = "";
                                                var classNameestadoA = "";
                                                if (ESTADOS_CON_NOVEDAD.includes(infoDetalle.estadol)) {
                                                    classNameestadoL = "small-error"
                                                }
                                                else if (JUSTIFICACIONES_MARCACION.includes(infoDetalle.estadol)) {
                                                    classNameestadoL = "textEspolColor-blue"
                                                }
                                                if (ESTADOS_CON_NOVEDAD.includes(infoDetalle.estadoa)) {
                                                    classNameestadoA = "small-error"
                                                }
                                                else if (JUSTIFICACIONES_MARCACION.includes(infoDetalle.estadoa)) {
                                                    classNameestadoA = "textEspolColor-blue"
                                                }

                                                var filasEstadosDetalleEntradaSalida = <div></div>

                                                if (infoDetalle.finSemanaFeriado) {
                                                    filasEstadosDetalleEntradaSalida = (
                                                        <td colSpan={7}>
                                                            <div className="small-error">
                                                                {"FIN DE SEMANA/FERIADO"}
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                                else {
                                                    filasEstadosDetalleEntradaSalida = (
                                                        <React.Fragment>
                                                            <td className="">
                                                                <div className={classNameestadoL}>
                                                                    {
                                                                        infoDetalle.estadol
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="">
                                                                <div className={classNameestadoA}>
                                                                    {
                                                                        infoDetalle.estadoa
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {
                                                                    <div>{infoDetalle.estadosolicitudnombrel}</div>
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    <div>{infoDetalle.estadosolicitudnombrea}</div>
                                                                }
                                                            </td>
                                                        </React.Fragment>
                                                    )
                                                }



                                                return (
                                                    <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleES " + indinfoHist}>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.fecha}
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.entradal}
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.entradaa}
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.salidaa}
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.salidal}
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.tiempohorariol}
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="">
                                                                {infoDetalle.duraciona}
                                                            </div>
                                                        </td>
                                                        {
                                                            filasEstadosDetalleEntradaSalida
                                                        }

                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>

                            <div className="mt-1">
                                <span className="bold"> *Registro completo - {explicacionEstadoRC} </span>
                            </div>
                            <div>
                                <span className="bold"> *Registro incompleto - {explicacionEstadoRI} </span>
                            </div>
                            <div>
                                <span className="bold"> *Registro excedido - {explicacionEstadoRE} </span>
                            </div>
                            <div>
                                <span className="bold"> *Ausencia de registro - {explicacionEstadoAR} </span>
                            </div>
                        </>

                    }

                    {
                        consultaApiCalendario &&
                        <CalendarComponent
                            cedula={informacionModal.identificacion}
                            year={year}
                            month={month}
                            canNavigate={false}
                        />
                    }



                </>

            return tabla;
        }
    }, [state.stateModalDetalle])

    useEffect(() => {
        ObtenerInformacionGeneral();
        updateTableHeight();
        window.addEventListener('resize', updateTableHeight); // Update height on window resize

        return () => {
            window.removeEventListener('resize', updateTableHeight); // Remove event listener on component unmount
        };


    }, [])


    const TablaPersonal = useMemo(() => {

        if (state.listadoPersonal.length > 0) {

            return (
                <TablaPersonalMarcaciones
                    informacion={state.listadoPersonal}
                    //onClickVerMarcaciones={(idPersona: number, nombre: string, identificacion: string) => ConsultarDetalleMarcaciones(idPersona, nombre, identificacion, state.stateModalDetalle.month, state.stateModalDetalle.year)}
                    onClickVerMarcaciones={(idPersona: number, nombre: string, identificacion: string) => ConsultarDetalleMarcaciones(idPersona, nombre, identificacion, state.mesActual, state.anioActual)}
                    onClickDescargarHojaMarcaciones={(identificacion: string, mesconsulta: number, fechaactual: string) => DescargarHojaMarcaciones(identificacion,mesconsulta,fechaactual)}
                    mesConsulta={state.mesActual}
                    fechaActual={state.fechaActual}
                />
            )
        }
        else if (state.listadoPersonal.length === 0 && state.novedad) {
            return (
                <div></div>
                //<div>Ha ocurrido un inconveniente al tratar de obtener con la información del personal</div>
            )
        }
        else {

            return (
                <div>No hay personal disponible para mostrar</div>
            )

        }

    }, [state.listadoPersonal, state.stateModalDetalle.year, state.stateModalDetalle.month, state.mesActual, state.anioActual])

    const ModalDetalle = useMemo(() => {

        const { month, year, idPersona, identificacion, consultaApiCalendario } = state.stateModalDetalle;

        const tabla: React.ReactElement = GenerarTablaDetalleMarcacion(state.stateModalDetalle);

        return (
            <ModalConfirmacion
                //show={state.stateModalDetalle.loading || state.stateModalDetalle.informacion.detalle.length > 0}
                show={state.stateModalDetalle.identificacion !== ""}
                size='xl'
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={true}
                classNameContentModal={"modal-body-personalMarcaciones"}
                // classNameAllModal={"modalPersonalMarcaciones"}
                mensajeConfirmacion=''
                hideBotonCerrar={true}
                nombreBotonAccion='Cerrar'
                onClose={() => dispatch({ type: "CERRAR_MODAL", payload: { month, year, idPersona, identificacion, consultaApiCalendario: false } })}
                contentModal={tabla}
                centered={true}
                tituloModal='Detalles Marcación del mes'
            />
        )

    }, [state.stateModalDetalle])


    const opcionesMeses = () => {
        if (state.anioActual <= 2024) {
            return listadoMeses.filter((v) => v.valorMes >= 11)
        }
        else {
            return [...listadoMeses]
        }
    }

    return (

        <div className="content">

            <h4 className="title">Consulta de marcaciones</h4>

            {state.loadingInfo && <Cargando />}
            {!state.loadingInfo &&
                <>
                    <Container fluid>
                        {/* <Row className="mb-3">
                            <Col md={12}>
                                <AlertNew
                                    cabeceraTitulo={"Para su conocimiento"}
                                    mensaje={"El registro de marcaciones de entrada y salida en lectores biométricos será actualizado al día siguiente."}
                                    tipo={TiposAlerta.SOLICITUD_VACACIONES}

                                    oncloseElement={() => { ; }}
                                />
                            </Col>
                        </Row> */}

                    </Container>
                    <Container fluid>
                        <Row form className="justify-content-start mb-1">
                            <Col className={"mr-auto ml-auto text-left"} xl={9} md={{ size: 11 }}>
                                <div style={{ width: "16.6667%" }}> {/* 2 de ancho dentro de 12 columnas */}
                                    <Label for="mesConsulta">
                                        Mes consulta:
                                    </Label>
                                    <Input id="selectMonth" type="select" name={"month"} value={state.mesActual} onChange={(e) => {
                                        //dispatch({ type: "ACTUALIZAR_MES_CONSULTA", payload: +e.target.value })
                                        ObtenerInformacionGeneral(+e.target.value)
                                    }}>
                                        {

                                            opcionesMeses().map((v, i) => {
                                                return (
                                                    <option value={v.valorMes}>{v.mes}</option>
                                                )
                                            })

                                        }
                                    </Input>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    {TablaPersonal}
                </>
            }

            {ModalDetalle}

            <ModalCargando
                show = {state.loadingHoja}
                size='md'
                onClose={() => dispatch({type:"HOJA_DESCARGADA"})}
                textoCargando='Descargando Hoja'                   
            />
        </div>
    )
}
